// File kinds the viewer understands, by extension. Previewable kinds are fetched
// as a blob and re-typed with `mime` (old S3 objects carry no Content-Type).
const KINDS = {
  png: { kind: "image", mime: "image/png", label: "PNG", color: "#7c5cfc" },
  jpg: { kind: "image", mime: "image/jpeg", label: "JPG", color: "#7c5cfc" },
  jpeg: { kind: "image", mime: "image/jpeg", label: "JPG", color: "#7c5cfc" },
  pdf: { kind: "pdf", mime: "application/pdf", label: "PDF", color: "#e53935" },
  csv: { kind: "csv", mime: "text/csv", label: "CSV", color: "#2e7d32" },
  xlsx: { kind: "other", label: "XLSX", color: "#2e7d32" },
  docx: { kind: "other", label: "DOCX", color: "#1976d2" },
};

export const fileExt = (name = "") => (name.includes(".") ? name.split(".").pop().toLowerCase() : "");

export const fileType = (name) => KINDS[fileExt(name)] || { kind: "other", label: (fileExt(name) || "FILE").toUpperCase(), color: "#757575" };

export const isPreviewable = (name) => fileType(name).kind !== "other";

// Stored names are "FIXDESK_<ticket><20-digit timestamp>_<original>"; show the
// original. A file downloaded from FixDesk and uploaded again carries the prefix
// twice, so strip every leading one.
export const displayName = (name = "") => {
  let out = name;
  while (/^FIXDESK_.*?\d{20}_/.test(out)) out = out.replace(/^FIXDESK_.*?\d{20}_/, "");
  return out || name;
};

// "Renuka · 02 Nov" style meta line.
export const fileMeta = (by, time) => {
  const d = time ? new Date(time) : null;
  const when = d && !isNaN(d.getTime()) ? d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" }) : "";
  return [by, when].filter(Boolean).join(" · ");
};

// Fetches a (presigned, cross-origin) URL as a blob typed for the browser.
export const fetchBlob = async (url, name) => {
  const res = await fetch(url);
  if (!res.ok) throw new Error("Could not load the file");
  const blob = await res.blob();
  const { mime } = fileType(name);
  return mime ? new Blob([blob], { type: mime }) : blob;
};

// Saves through a blob so the browser downloads (a cross-origin link with
// `download` is ignored) and keeps the original file name.
export const downloadFile = async (url, name) => {
  const blob = await fetchBlob(url, name);
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = displayName(name);
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 10000);
};

// Minimal CSV parser (quoted fields, escaped quotes, CRLF) for the table preview.
export const parseCsv = (text) => {
  const rows = [];
  let row = [];
  let cell = "";
  let quoted = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (quoted) {
      if (ch === '"' && text[i + 1] === '"') { cell += '"'; i++; }
      else if (ch === '"') quoted = false;
      else cell += ch;
    } else if (ch === '"') quoted = true;
    else if (ch === ",") { row.push(cell); cell = ""; }
    else if (ch === "\n" || ch === "\r") {
      if (ch === "\r" && text[i + 1] === "\n") i++;
      row.push(cell); rows.push(row); row = []; cell = "";
    } else cell += ch;
  }
  if (cell || row.length) { row.push(cell); rows.push(row); }
  return rows;
};
